<template>
    <img :src="encodedImage" :title="url" />
</template>

<script>
    import QRCode from 'qrcode'

    export default {
        name: "QrCode",
        props: {
            url: {
                default: 'google.com',
                type: String
            }
        },
        data() {
            return {
                encodedImage: ''
            }
        },
        mounted() {

            let _this = this
            QRCode.toDataURL(this.url, { errorCorrectionLevel: 'M' }, function (err, url) {
                console.log(url)
                _this.encodedImage = url
            })

        }

    }
</script>

<style scoped>

</style>
